"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const constants_1 = __importStar(require("@/constants"));
const __1 = require("..");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const FormError = ({ formError }) => {
    if (!formError)
        return null;
    let errorMessage = constants_1.default.general.thereWasAnError;
    if (formError.details && typeof formError.details === 'string') {
        errorMessage = formError.details;
    }
    return (React.createElement("div", { className: styles_scss_1.default.bannerContainer },
        React.createElement(__1.Banner, { borderRadius: styles_scss_1.default.smallestSpacer, icon: constants_1.Images.apiError, backgroundColor: styles_scss_1.default.bannerRed, description: errorMessage, width: styles_scss_1.default.widthBanner })));
};
const mapStateToProps = (state, props) => ({ formError: radio_dispatch_1.selectors.getError(state, props.formKey), });
exports.default = (0, react_redux_1.connect)(mapStateToProps)(FormError);
